module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/partner-customer-voice-image.c28d20f2.png";